// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';

import BulkOperationModalActions from 'ion-experimental/app/shared/bulk-operations/BulkOperationModalActions';

export default function ModalActions({
  uploadState,
  onCancel,
  onUpload,
  onClose,
  onDownloadReport,
  canUpload,
  UPLOAD_STATE,
}) {
  return (
    <BulkOperationModalActions
      isIdle={uploadState === UPLOAD_STATE.IDLE}
      isProcessing={uploadState === UPLOAD_STATE.PROCESSING}
      isComplete={uploadState === UPLOAD_STATE.COMPLETE}
      canUpload={canUpload}
      onCancel={onCancel}
      onUpload={onUpload}
      onClose={onClose}
      onDownloadReport={onDownloadReport}
      uploadButtonTestId="bulk-create-upload-button"
      downloadButtonTestId="bulk-create-download-report-button"
      closeButtonTestId="bulk-create-close-button"
    />
  );
}

ModalActions.propTypes = {
  uploadState: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownloadReport: PropTypes.func.isRequired,
  canUpload: PropTypes.bool.isRequired,
  UPLOAD_STATE: PropTypes.object.isRequired,
};
